/**
 * @generated SignedSource<<3ce11fe803ce3ee1884a6393aee1a87e>>
 * @relayHash c65404aa4339865deb33b960b63ac1fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366

import type { ConcreteRequest } from 'relay-runtime';
export type useSpaceBaseQuerySingleSpaceQuery$variables = {
  spaceKey?: string | null;
};
export type useSpaceBaseQuerySingleSpaceQuery$data = {
  readonly space: {
    readonly alias: string | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
  } | null;
};
export type useSpaceBaseQuerySingleSpaceQuery = {
  response: useSpaceBaseQuerySingleSpaceQuery$data;
  variables: useSpaceBaseQuerySingleSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "alias"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceBaseQuerySingleSpaceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceBaseQuerySingleSpaceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c65404aa4339865deb33b960b63ac1fb",
    "id": "e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366",
    "metadata": {},
    "name": "useSpaceBaseQuerySingleSpaceQuery",
    "operationKind": "query",
    "text": "query useSpaceBaseQuerySingleSpaceQuery($spaceKey:String){space(key:$spaceKey){id,key,name,alias}}"
  }
};
})();

(node as any).hash = "0994a40a61365970e08e840dbdb433df";

export default node;
